import { Chess } from "chess.js";
import { Pgn } from "cm-pgn/src/Pgn.js";
import { PlayerColor, Settings } from "./models";
import * as Sentry from "@sentry/react";

const traverseVariation = (variation: any) => {
    let fens: string[] = [];
    for (const move of variation) {
        fens.push(move.fen.split(" ").slice(0, 3).join(" "));
        for (const subVariation of move.variations) {
            fens = [...fens, ...traverseVariation(subVariation)];
        }
    }
    return fens;
};

export const getAllFensInPgn = (pgn: string) => {
    try {
        const chess = new Pgn(pgn, { sloppy: true });
        const fens = traverseVariation(chess.history.moves);

        return fens;
    } catch (error) {
        console.log(error);
        alert("OpeningTrainer could not parse the PGN. Error: " + error);
        throw error;
    }
};

export const isCurrentPositionInRepo = (fen: string, settings: Settings, playerColor: PlayerColor) => {
    const repo = playerColor === "w" ? settings.whiteRepo : settings.blackRepo;
    if (!repo) {
        return false;
    }

    const fens = getAllFensInPgn(repo.content);
    const currentPosition = fen.split(" ").slice(0, 3).join(" ");
    return fens.includes(currentPosition);
};
